const BLOCKED_EMAIL_DOMAINS = new Set([
  'ru',
  'su',
  'рф',
  'mail.ru',
  'bk.ru',
  'inbox.ru',
  'list.ru',
  'internet.ru',
  'xmail.ru',
  'yandex.ru',
  'yandex.com',
  'yandex.by',
  'yandex.kz',
  'yandex.uz',
  'yandex.com.tr',
  'ya.ru',
  'ya.cc',
  'rambler.ru',
  'rambler.ua',
  'rambler.kz',
  'lenta.ru',
  'autorambler.ru',
  'ro.ru',
  'myrambler.ru',
  'vk.com',
  'vk.ru',
  'pochta.ru',
  'sber.ru',
  'tinkoff.ru',
]);

const BLOCKED_SUFFIXES = ['.ru', '.su', '.рф', '.yandex.com', '.yandex.by', '.yandex.kz', '.yandex.uz', '.rambler.ua', '.rambler.kz'];

export const normalizeEmailInput = (value) => value.trim().toLowerCase();

export const russianEmailError = (value) => {
  const email = normalizeEmailInput(value);
  const [, rawDomain = ''] = email.split('@');
  const domain = rawDomain.replace(/\.+$/, '');
  if (!domain) return '';
  const labels = domain.split('.');
  const registrableDomain = labels.length >= 2 ? labels.slice(-2).join('.') : domain;
  if (
    BLOCKED_EMAIL_DOMAINS.has(domain)
    || BLOCKED_EMAIL_DOMAINS.has(registrableDomain)
    || BLOCKED_SUFFIXES.some((suffix) => domain.endsWith(suffix))
  ) {
    return 'Российская почта не поддерживается. Используйте Gmail, Proton, iCloud или другой зарубежный email.';
  }
  return '';
};
